import type { PageStackTree } from '@lighthouse/core'

import { getNode } from '../page/utils'

/**
 * 是否符合给定的page stack
 * @date 9/20/2023 - 6:42:52 PM
 *
 * @returns {(stack: PageMetaData) => boolean}
 */
export const equalPageStack = (stackId: string) => (tree: PageStackTree | null) => {
    if (!tree) {
        return
    }
    return getNode(stackId)(tree)
}
